import { useContext, useEffect, useState } from 'react';
import { PlatformOption } from '../types/ApiTypes';
import { ReviewOptionsProps } from '../types/PropsTypes';
import { PlatformButton } from './PlatformButton';
import { getPlatformOptionReviewType } from '../services/ReviewProcessService';
import { Avatar, Button, Group, TextInput, Text } from '@mantine/core';
import { CompanyContext } from '../contexts/CompanyContext';
import { InviteContext } from '../contexts/InviteContext';

export function ReviewOptions({
  platformOptions,
  onSelect,
}: ReviewOptionsProps): JSX.Element {
  const { company } = useContext(CompanyContext);
  const { invite } = useContext(InviteContext);

  const [showAll, setShowAll] = useState(false);
  const [name, setName] = useState([invite?.firstname, invite?.lastname].filter(Boolean).join(" "));

  const priorityOptions = platformOptions.filter(
    (platformOption) => platformOption.secondary_priority,
  );
  const nonPriorityOptions = platformOptions.filter(
    (platformOption) => !platformOption.secondary_priority,
  );

  useEffect(()=>{
    // we will just redirect to the only option instead of having a way to select review option
    // if they select 1-3 stars it wont ever hit this component
    if(platformOptions.length === 1){
      onSelect(
        platformOptions[0].DOMid,
        platformOptions[0].url,
        getPlatformOptionReviewType(platformOptions[0].DOMid),
      )
    }
  },[])

  return (
    <div className="centered-stack">
      {company && company.allowAnonymous &&
        <Group maw={475} w={'100%'} pb={10} mb={10} style={{borderBottom: '1px solid lightgray'}}>

          <TextInput
            flex={1}
            value={name}
            onChange={(e)=>setName(e.currentTarget.value)}
            placeholder={"John Doe"}
            label={
              <Group mb={5}>
                <Avatar size={'sm'} color='gray' aria-label='step 1'>1</Avatar>
                <Text fw={'bolder'}>What is your name? <span style={{color:'lightslategray'}}>(optional)</span> </Text>
              </Group>
            }
          />
        </Group>
      }
      {company && company.allowAnonymous &&
       <Group maw={475} w={'100%'} wrap={'nowrap'}>
         <Avatar color='gray' size={'sm'} aria-label='step 2'>2</Avatar>
         <Text fw={'bolder'}>Select below where you would like to leave your review</Text>
       </Group>
      }
      {priorityOptions.map((writtenButton: PlatformOption) => (
        <PlatformButton
          key={writtenButton.name}
          writtenButton={writtenButton}
          onClick={() =>
            onSelect(
              writtenButton.DOMid,
              writtenButton.url,
              getPlatformOptionReviewType(writtenButton.DOMid),
              name.trim()
            )
          }
        />
      ))}
      {nonPriorityOptions.length > 0 ? (
        showAll ? (
          nonPriorityOptions.map((writtenButton: PlatformOption) => (
            <PlatformButton
              key={writtenButton.name}
              writtenButton={writtenButton}
              onClick={() =>
                onSelect(
                  writtenButton.DOMid,
                  writtenButton.url,
                  getPlatformOptionReviewType(writtenButton.DOMid),
                  name.trim()
                )
              }
            />
          ))
        ) : (
          <Button
            radius={'lg'}
            my={'lg'}
            color="gray"
            onClick={() => setShowAll(true)}
          >
            More Options
          </Button>
        )
      ) : null}

      <Text style={{fontStyle: 'italic', textAlign: 'center'}} size={'xs'} color={'gray.6'} maw={600} mt={'sm'}>
        By submitting a review to {company?.name ?? "SoTellUs"}, you authorize the unrestricted use of your review by SoTellUs and by the person/entity that requested the review. You hereby grant the unrestricted, irrevocable, worldwide, royalty-free right and license to copyright and use, re-use, publish, and republish photos, videos, and/or audio recordings of me or in which I may be included, intact or in part, in composite or distorted in character or form, without restriction as to changes, for unlimited purposes (both commercial and non-commercial), and through any and all media and methods of distribution, now known or hereafter developed. All rights of privacy and publicity are hereby waived, including the right to use my name with my photos and/or videos.
      </Text>
    </div>
  );
}
